import { render, staticRenderFns } from "./su2QuestionsComponent.vue?vue&type=template&id=b8b58cf8&scoped=true"
import script from "./su2QuestionsComponent.vue?vue&type=script&lang=js"
export * from "./su2QuestionsComponent.vue?vue&type=script&lang=js"
import style0 from "./su2QuestionsComponent.vue?vue&type=style&index=0&id=b8b58cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b58cf8",
  null
  
)

export default component.exports